import Trip from "../../model/Trip";
import { TripActionTypes } from "./types";
import { Reducer } from "../../lib/redux";
import { TripActions } from "./actions";
import { extend, hashToArray } from "../../utils/vanilla";

export let defaultTrips: IIdDictionary<IIdDictionary<Trip>> = {};

export let trips: Reducer<IIdDictionary<IIdDictionary<Trip>>, TripActions> = (state = defaultTrips, action) => {
    switch (action.type) {
        case TripActionTypes.SET_TRIPS: {
            const userId = action.payload.userId;
            if (userId) {
                return {
                    ...state,
                    [userId]: extend(true, {}, action.payload.trips)
                };
            }
            return state;
        }
        case TripActionTypes.CLEAR_TRIPS: {
            const userId = action.payload;
            if (userId) {
                let newState = { ...state };
                delete newState[userId];
                return newState;
            }
            return {};
        }
        default:
            return state;
    }
};

/** Trips that started or stopped since `startOfDayIso` (legacy ui/main.ts getTripsCount). */
export const countTripsSince = (userTrips: IIdDictionary<Trip> | undefined, startOfDayIso: string): number => {
    return hashToArray<Trip>(userTrips || {}).filter(trip =>
        (trip.start && trip.start >= startOfDayIso) || (trip.stop && trip.stop >= startOfDayIso)).length;
};

export let defaultTripsTodayCount: IIdDictionary<number> = {};

/**
 * Per user, how many trips started or stopped today, kept in step with trips by the same actions. Derived for
 * the native dashboard, which has no trip data; the web app does not read it. The day boundary comes from the
 * action (a reducer cannot read the clock), so the count is as of the last trips update; it is not stored
 * across restarts because a count from an earlier day would be wrong.
 */
export let tripsTodayCount: Reducer<IIdDictionary<number>, TripActions> = (state = defaultTripsTodayCount, action) => {
    switch (action.type) {
        case TripActionTypes.SET_TRIPS: {
            const { userId, startOfDay } = action.payload;
            if (!userId || !startOfDay) {
                return state;
            }
            const count = countTripsSince(action.payload.trips, startOfDay);
            return state[userId] === count ? state : { ...state, [userId]: count };
        }
        case TripActionTypes.CLEAR_TRIPS: {
            const userId = action.payload;
            if (userId) {
                const next = { ...state };
                delete next[userId];
                return next;
            }
            return {};
        }
        default:
            return state;
    }
};
